// Thank-you page (User Story 1, final step). Shown after a successful inquiry
// submission. Renders the admin-configured confirmation copy (heading + body);
// any follow-up contact email is part of the body text. Copy comes from the
// app-wide settings slice (populated from /api/public-config on mount).
import { useSelector } from 'react-redux';
import {
  Box, Container, Typography, Button,
} from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { selectSettings } from '../store/settings-slice.js';

const ThankYouPage = () => {
  const settings = useSelector(selectSettings);

  return (
    <Container maxWidth="sm">
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h1" gutterBottom>{settings.thank_you_title}</Typography>
        <Typography variant="body1" sx={{ mb: 4, whiteSpace: 'pre-line' }}>
          {settings.thank_you_body}
        </Typography>
        <Button component={RouterLink} to="/" variant="outlined">
          Return home
        </Button>
      </Box>
    </Container>
  );
};

export default ThankYouPage;
